import { styled } from "@stitches/react";
import { useMetrics } from "@/hooks/use-metrics";
import MetricsTable from "@/components/MetricsTable";
import { useAppState } from "@/contexts/app-state";
import { useOrders } from "@/hooks/use-orders";
import { objectToCSV } from "@/utils/helpers";
import { useMetricsContext } from "@/contexts/metrics-context";
import { MetricsFilters } from "@/types/metrics";
import { AUTH_STATUS_BACKEND } from "@/components/OrderTable/constants";
import { Order } from "@/types/my-tasks";
import { useEffect, useState } from "react";
import { Button } from "@/vendor/Forge/dist";
import Loader from "@/components/Loader";
import FiltersTableMetrics from "@/components/FiltersTableMetrics";
import { useNavigate } from "react-router-dom";

const Wrapper = styled("div", {
  padding: "0 16px",
  display: "flex",
  marginBottom: "50px",
  overflowX: "scroll",

  "& table": {
    width: "100%",
  },
  "& table th, & table td": {
    border: "1px solid #B6B7B7",
  },
  "& table th:first-child, & table td:first-child": {
    borderLeft: "none",
    padding: "0px",
    width: "25px",
  },
  "& .fe_c_table.fe_c_table--compact tbody td.fe_c_table__cell": {
    padding: "8px 12px",
  },
  "& .fe_c_table.fe_c_table--compact thead th.fe_c_table__header": {
    padding: "16px 12px",
  },
  "& tfoot > tr > td": {
    padding: "8px 12px",
    fontSize: 14,
  },
  "& tfoot > tr > td:first-child": {
    fontWeight: "bold",
  },
});

const TableContainer = styled("div", {
  display: "flex",
  flexFlow: "column",
  minWidth: "900px",
});

const TableButtonsContainer = styled("div", {
  display: "flex",
  flexFlow: "row",
  justifyContent: "space-between",
  marginLeft: "75px",
  padding: "16px",
  paddingTop: "0px",
});

const OrdersData = (filters: MetricsFilters) => {
  const { currentUser, loggedInUser } = useAppState();
  const {
    data = { total: 0, rows: [], tabData: [], totalPages: 0, totalCount: 0 },
    isPending,
    isError,
  } = useOrders({
    user: loggedInUser,
    filters,
    bucketName: currentUser,
    sortBy: "",
  });

  return { data, isPending, isError };
};

const Metrics = () => {
  const [csvData, setCsvData] = useState("");
  const { currentUser } = useAppState();
  const { filters } = useMetricsContext();
  const metricsFilters = {
    performDateRangeStar: [filters?.performDateRangeStart],
    performDateRangeEn: [filters?.performDateRangeEnd],
    insurances: filters?.insurances,
    orderNames: filters?.orderNames,
    authStatus: AUTH_STATUS_BACKEND,
  };
  const getOrders = OrdersData(metricsFilters);
  const navigate = useNavigate();

  useEffect(() => {
    if (getOrders.data === null) {
      navigate(`/error`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [getOrders.data]);

  useEffect(() => {
    if (getOrders?.data?.rows?.length) {
      const csv = objectToCSV<Order>(getOrders.data.rows, {
        excludes: ["allUsers", "approvedBy"],
      });
      setCsvData(csv);
    }
  }, [getOrders.data.rows]);

  const {
    data = {
      userMetricsList: [],
      totalCounts: {
        totalCount: 0,
        notStartedCount: 0,
        pendingCount: 0,
        obtainedCount: 0,
        closedCount: 0,
        notRequiredCount: 0,
      },
    },
    isPending,
    refetch,
    error,
    isError,
  } = useMetrics({ bucketName: currentUser });

  //this is hacky, seek better option when available
  const downloadCsv = () => {
    const data = new Blob([csvData], { type: "text/csv" });
    const csvUrl = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = csvUrl;
    link.download = "orders.csv";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };
  // Replace with actual condition to show error page

  return (
    <Wrapper>
      <FiltersTableMetrics />
      <TableContainer>
        <TableButtonsContainer>
          <Button onClick={() => void refetch()}>Refresh Data</Button>
          <Button disabled={getOrders.isPending} onClick={downloadCsv}>
            Download Orders
          </Button>
        </TableButtonsContainer>
        <Loader
          isLoading={isPending}
          displayText="Loading Metrics..."
          isError={isError}
          errorReason={error?.message}
        >
          <MetricsTable
            rows={data?.userMetricsList}
            totalCounts={data?.totalCounts}
          />
        </Loader>
      </TableContainer>
    </Wrapper>
  );
};
export default Metrics;
